module.exports = __webpack_public_path__ + "img/aej1n-66wvl.031.679f9b19.png";